/* The eager half of `/label/audit`. See `library/pages/dataset-search.ts` for why a
 * route's search vocabulary lives apart from the screen that reads it. */

import { enumParam, integerParam, stringParam } from "../../../lib/url-state";
import type { RowFilter } from "./AuditPage";

const FILTERS: readonly RowFilter[] = [
  "all",
  "unaudited",
  "rejected",
  "redo",
  "approved",
];

/** What an audit address carries beside the episode.
 *
 * `author` is a filter, not the page's identity: the page is the audit, and picking a seat
 * narrows which submissions it lists, exactly as `filter` and `q` do. It stays in the query
 * for that reason and for one more — an episode belongs to exactly one author, so the seat
 * is context the episode already implies rather than a second coordinate. (The list an
 * episode is opened from is that author's, which is why an episode address with no author
 * lands on the seat picker, as it always has.) */
interface AuditFilters {
  readonly author?: number;
  readonly filter?: RowFilter;
  readonly q?: string;
}

export function parseAuditFilters(
  search: Record<string, unknown>,
): AuditFilters {
  return {
    author: integerParam(search.author, { min: 1 }),
    filter: enumParam(search.filter, FILTERS),
    q: stringParam(search.q),
  };
}
